<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="280px"
    >
      <el-form-item
        label="数据时间"
        prop="reportTime"
        style="margin-right:15px"
      >
        <el-date-picker
          v-model="form.reportTime"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @change="dataSet"
        />
      </el-form-item>
      <el-form-item
        label="实际承运人信用查询次数"
        prop="carrierCreditCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.carrierCreditCount"
          placeholder="请输入实际承运人信用查询次数"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')} "
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="信用查询次数-车辆"
        prop="vehicleCreditCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.vehicleCreditCount"
          placeholder="请输入信用查询次数-车辆"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')} "
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          type="number"
        />
      </el-form-item>
      <el-form-item
        label="驾驶员信用查询次数"
        prop="driverCreditCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.driverCreditCount"
          placeholder="请输入驾驶员信用查询次数"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')} "
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          type="number"
        />
      </el-form-item>
      <el-form-item
        label="发生赔付次数"
        prop="insuranceCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.insuranceCount"
          placeholder="请输入发生赔付次数"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')} "
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          type="number"
        />
      </el-form-item>
      <el-form-item
        label="完成赔付次数"
        prop="insuranceClaimCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.insuranceClaimCount"
          placeholder="请输入完成赔付次数"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')} "
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          type="number"
        />
      </el-form-item>
      <el-form-item
        label="完成赔付金额"
        prop="insuranceFnishedAmount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.insuranceFnishedAmount"
          placeholder="请输入完成赔付金额"
          type="number"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')} "
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="运输生产安全事故次数"
        prop="transportAccidentCount"
        style="margin-right:15px"
        onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')} "
        onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
      >
        <el-input
          v-model="form.transportAccidentCount"
          placeholder="请输入运输生产安全事故次数"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')} "
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
          type="number"
        />
      </el-form-item>
      <el-form-item
        label="运输生产安全事故处理次数"
        prop="transportAccidentFinishedCount"
        style="margin-right:15px"
        onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')} "
        onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
      >
        <el-input
          v-model="form.transportAccidentFinishedCount"
          placeholder="请输入运输生产安全事故处理次数"
        />
      </el-form-item>
      <el-form-item
        label="服务质量投诉次数"
        prop="serviceProblemCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.serviceProblemCount"
          placeholder="请输入服务质量投诉次数"
          type="number"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')} "
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="服务质量投诉完成处理次数"
        prop="serviceProblemHandleCount"
        style="margin-right:15px"
        onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')} "
        onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
      >
        <el-input
          v-model="form.serviceProblemHandleCount"
          placeholder="请输入服务质量投诉完成处理次数"
          type="number"
        />
      </el-form-item>
      <el-form-item
        label="增值税开票资格"
        prop="billingQualification"
        style="margin-right:15px"
      >
        <el-select
          v-model="form.billingQualification"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in sendOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="开票数"
        prop="billingCount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.billingCount"
          placeholder="请输入开票数"
          type="number"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')} "
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="开票金额"
        prop="billingAmount"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.billingAmount"
          placeholder="请输入开票金额"
          type="number"
          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')} "
          onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="上报状态"
        prop="isSend"
        style="margin-right:15px"
      >
        <el-select
          v-model="form.isSend"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in sendFundOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";

export default {
  name: "FieldRequiredSettingAdd",
  data() {
    return {
      form: {
        reportTime: "",
        carrierCreditCount: "",
        vehicleCreditCount: "",
        driverCreditCount: "",
        insuranceCount: "",
        insuranceClaimCount: "",
        insuranceFnishedAmount: "",
        transportAccidentCount: "",
        transportAccidentFinishedCount: "",
        serviceProblemCount: "",
        serviceProblemHandleCount: "",
        billingQualification: "",
        billingCount: "",
        billingAmount: "",
        isSend: "",
      },
      sendFundOptions: [
        {
          value: "0",
          label: "未上报",
        },
        {
          value: "1",
          label: "已上报",
        },
        {
          value: "2",
          label: "上报失败",
        },
      ],
      sendOptions: [
        {
          value: "0",
          label: "无",
        },
        {
          value: "1",
          label: "有",
        },
      ],
      rules: {
        reportTime: [
          { required: true, message: "请输入数据月份实际", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        carrierCreditCount: [
          {
            required: true,
            message: "请输入实际承运人信用查询次数",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        vehicleCreditCount: [
          {
            required: true,
            message: "请输入车辆信用查询次数",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        driverCreditCount: [
          {
            required: true,
            message: "请输入驾驶员信用查询次数",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        insuranceCount: [
          {
            required: true,
            message: "请输入发生赔付次数",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        insuranceClaimCount: [
          {
            required: true,
            message: "请输入保险完成赔付次数",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        insuranceFnishedAmount: [
          {
            required: true,
            message: "请输入保险赔付金额（元）",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        transportAccidentCount: [
          {
            required: true,
            message: "请输入运输生产安全事故次数",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        transportAccidentFinishedCount: [
          {
            required: true,
            message: "请输入运输生产安全事故完成处理次数",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        serviceProblemCount: [
          {
            required: true,
            message: "请输入服务质量投诉发生次数",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        serviceProblemHandleCount: [
          {
            required: true,
            message: "请输入服务质量投诉完成处理次数",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        billingQualification: [
          {
            required: true,
            message: "开票资格0表示无，1表示有",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1,
            message: "开票资格0表示无，1表示有",
            trigger: "blur",
          },
        ],
        billingCount: [
          {
            required: true,
            message: "请输入开票数（份）",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        billingAmount: [
          {
            required: true,
            message: "请输入开票金额（元）",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        isSend: [
          {
            required: true,
            message: "请输入上报状态",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1,
            message: "是否上报，0否，1是，2失败",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.initData({});
  },
  methods: {
    dataSet() {
      this.getListByDay();
      //console.log(this.form.reportTime);
    },
    async initData(data) {
      //获取当前时间
      var now = new Date();
      var monthn = now.getMonth() + 1;
      var yearn = now.getFullYear();
      var dayn = now.getDate();
      this.selectDay = yearn + "-" + monthn + "-" + dayn;

      this.selectUser = parseInt(sessionStorage.getItem("userid"));
      this.getListByDay();
    },
    async getListByDay(data) {},
    //提交
    funcSubmit() {
      //console.log(this.form.carrierCreditCount)
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/creditQuality",
            method: "post",
            params: data,
          })
            .then((response) => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherAddMethod");
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    //只能输入数字
    myInputNum() {
      this.myValue = this.myValue.replace(/[^\d]/g, "");
    },
    //取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
    },
    isFloor(e) {
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
